import { render, staticRenderFns } from "./LoadingCard.vue?vue&type=template&id=35667c06&scoped=true&"
import script from "./LoadingCard.vue?vue&type=script&lang=js&"
export * from "./LoadingCard.vue?vue&type=script&lang=js&"
import style0 from "./LoadingCard.vue?vue&type=style&index=0&id=35667c06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35667c06",
  null
  
)

export default component.exports